import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"subheader col-6\"><h1 class=\"subheader-title\">商品マスタ一覧</h1></div><div class=\"subheader-block ml-auto demo\"><button type=\"button\" class=\"btn btn-success waves-effect waves-themed\"><span class=\"fal fa-download mr-1\"></span>Excel出力 </button><button type=\"button\" class=\"btn btn-info waves-effect waves-themed\"><span class=\"fal fa-plus mr-1\"></span>追加 </button></div></div>", 1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-xl-12" }
const _hoisted_5 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "検索条件"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1)
const _hoisted_7 = { class: "panel-container show" }
const _hoisted_8 = { class: "panel-content contents" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-md-1 contTitle\">商品コード</div><div class=\"col-md-5 contCnt input-daterange input-group\"><input type=\"text\" name=\"txtClientCdFrom\" class=\"form-control form-control-sm\" maxlength=\"5\"><span class=\"input-group-addon\">－</span><input type=\"text\" name=\"txtClientCdTo\" class=\"form-control form-control-sm\" maxlength=\"5\"></div><div class=\"col-md-1 contTitle\">商品名</div><div class=\"col-md-5 contCnt\"><input type=\"text\" name=\"txtClientNm\" class=\"form-control form-control-sm\" maxlength=\"200\"></div></div>", 1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "商品種別", -1)
const _hoisted_12 = { class: "col-md-5 contCnt" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "所属", -1)
const _hoisted_14 = { class: "col-md-5 contCnt" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-md-1 contTitle\">エリア</div><div class=\"col-md-5 contCnt\"><input type=\"text\" name=\"txtClientNm\" class=\"form-control form-control-sm\" maxlength=\"200\"></div></div><div class=\"row\"><button type=\"button\" class=\"btn btn-primary waves-effect waves-themed btn-search mx-auto\"> 検索 </button></div>", 2)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-xl-12" }
const _hoisted_19 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "条件結果"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1)
const _hoisted_21 = { class: "panel-container show" }
const _hoisted_22 = { class: "panel-content" }
const _hoisted_23 = {
  key: 0,
  class: "gtablecell btnDetCell"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 1,
  class: "gtablecell"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_vSelect, {
                    multiple: "",
                    options: _ctx.optionsOp2
                  }, null, 8, ["options"])
                ]),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_vSelect, {
                    multiple: "",
                    options: _ctx.optionsOp3
                  }, null, 8, ["options"])
                ])
              ]),
              _hoisted_15
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_vue_good_table, {
                columns: _ctx.columns,
                rows: _ctx.rows,
                "sort-options": {
                  enabled: false,
                },
                "pagination-options": {
                  perPageDropdownEnabled: false,
                  enabled: true,
                  jumpFirstOrLast: true,
                  page: 1,
                  perPage: 10,
                  nextLabel: '次へ',
                  prevLabel: '前へ',
                  mode: 'pages',
                  ofLabel: '～',
                  pageLabel: '',
                },
                totalRows: _ctx.totalRecords
              }, {
                "table-row": _withCtx((props) => [
                  (props.column.field == '詳細ボタン')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-xs btn-block btn-primary waves-effect waves-themed",
                          onClick: ($event: any) => (_ctx.moveDet(props.row.link))
                        }, " 詳細 ", 8, _hoisted_24)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(props.formattedRow[props.column.field]), 1))
                ]),
                _: 1
              }, 8, ["columns", "rows", "totalRows"])
            ])
          ])
        ])
      ])
    ])
  ]))
}